import { Component, Input, OnChanges, Output, SimpleChanges, EventEmitter } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { atLeastOneRequiredValidator } from '../../../shared/utils/atLeastOneRequiredValidator';
import { RentalPropertyLicense } from '../../../domain/model/properties/rentalPropertyLicense';
import { CommonServices } from '../../../domain/service/commonService';
import { PropertyService } from '../../../domain/service/propertyService';
import { RentalProperty } from '../../../domain/model/properties/rentalProperty';

@Component({
  selector: 'app-properties-detail-license',
  templateUrl: './properties-detail-license.component.html',
  styleUrl: './properties-detail-license.component.css'
})
export class PropertiesDetailLicenseComponent implements OnChanges{
  constructor(private propertyService: PropertyService, private commonServices: CommonServices,private fb: FormBuilder) {}
  
  ngOnChanges(changes: SimpleChanges): void {
   this.buildForm(this.rentalPropertyLicenseModel);
  }
  @Input() rentalPropertyLicenseModel!: RentalPropertyLicense;  
   @Input() rentalProperty!: RentalProperty;
  @Output() formChanged: EventEmitter<boolean> = new EventEmitter<boolean>();
  rentalPropertyLicense!: FormGroup;
 
  private buildForm(data: RentalPropertyLicense | undefined): void {
    this.rentalPropertyLicense = this.fb.group({

      departmentOfBusiness: new FormControl(data?.regulationLicenseNumber, [Validators.pattern(/^[a-zA-Z1-9][a-zA-Z0-9]*$/)]),
      taxCertificateNumber: new FormControl(data?.taxCertificateNumber, [Validators.pattern(/^\d{2}-\d{10}-\d{1}$/)]),
      stateCertificateHasBeenApplied: new FormControl(data?.stateCertificateHasBeenApplied),
      reasonWhy: new FormControl(data?.reasonWhy),
      certificateOfRegistration: new FormControl(data?.certicateOfRegistration),
      localBusinessTaxReceipt: new FormControl(data?.taxReceipt),
      cityOfRegistration: new FormControl(data?.certicateOfRegistration),
    }, { validators: atLeastOneRequiredValidator(['reasonWhy', 'stateCertificateHasBeenApplied', 'taxCertificateNumber']) });
    this.rentalPropertyLicense
    .get("departmentOfBusiness")
    ?.valueChanges.subscribe(() => {
      this.rentalPropertyLicense.get("departmentOfBusiness")?.markAsTouched();
    });
  this.rentalPropertyLicense
    .get("stateCertificateHasBeenApplied")
    ?.valueChanges.subscribe((value) => {
      if (
        value &&
        this.rentalPropertyLicense.get("taxCertificateNumber")?.enabled &&
        this.rentalPropertyLicense.get("reasonWhy")?.enabled
      ) {
     
        this.rentalPropertyLicense.get("taxCertificateNumber")?.disable();
        this.rentalPropertyLicense.get("reasonWhy")?.disable();
      } else if (
        !value &&
        this.rentalPropertyLicense.get("taxCertificateNumber")?.disabled &&
        this.rentalPropertyLicense.get("reasonWhy")?.disabled
      ) {
        this.rentalPropertyLicense.get("taxCertificateNumber")?.enable();
        this.rentalPropertyLicense.get("reasonWhy")?.enable();
      }
    });
  this.rentalPropertyLicense
    .get("taxCertificateNumber")
    ?.valueChanges.subscribe((value) => {
      value = value.replace(/[^0-9\-]/g, "");
      this.rentalPropertyLicense.get("taxCertificateNumber")?.markAsTouched();

      if (value) { 
        this.rentalPropertyLicense
          .get("stateCertificateHasBeenApplied")
          ?.disable();
        this.rentalPropertyLicense.get("reasonWhy")?.disable();
      } else if (
        !value &&
        this.rentalPropertyLicense.get("reasonWhy")?.disabled
      ) {
        this.rentalPropertyLicense
          .get("stateCertificateHasBeenApplied")
          ?.enable();
        this.rentalPropertyLicense.get("reasonWhy")?.enable();
      }
    });

    this.rentalPropertyLicense
    .get("reasonWhy")
    ?.valueChanges.subscribe((value) => {;
      this.rentalPropertyLicense.get("reasonWhy")?.markAsTouched();

      if (value ) {
      
        this.rentalPropertyLicense
          .get("stateCertificateHasBeenApplied")
          ?.disable();
        this.rentalPropertyLicense.get("taxCertificateNumber")?.disable();
      } else if (
        !value &&
        this.rentalPropertyLicense.get("taxCertificateNumber")?.disabled &&
        this.rentalPropertyLicense.get("stateCertificateHasBeenApplied")?.disabled 
      ) {
        this.rentalPropertyLicense
          .get("stateCertificateHasBeenApplied")
          ?.enable();
        this.rentalPropertyLicense.get("taxCertificateNumber")?.enable();
      }
    });
    this.rentalPropertyLicense.valueChanges.subscribe(() => {
      this.formChanged.emit(this.rentalPropertyLicense.valid);
    });

  }

  public save(): void {
    let model : RentalPropertyLicense = {
      id: this.rentalPropertyLicenseModel?.id,
      accountId: this.rentalProperty.accountID,
      regulationLicenseNumber: this.rentalPropertyLicense?.get("departmentOfBusiness")?.value ?? "",
    certicateOfRegistration: this.rentalPropertyLicense?.get("cityOfRegistration")?.value ?? "",
    taxCertificateNumber: this.rentalPropertyLicense?.get("taxCertificateNumber")?.value ?? "",
    stateCertificateHasBeenApplied: this.rentalPropertyLicense?.get("stateCertificateHasBeenApplied")?.value ?? false,
    taxReceipt: this.rentalPropertyLicense?.get("localBusinessTaxReceipt")?.value ?? "",
    reasonWhy: this.rentalPropertyLicense?.get("reasonWhy")?.value ?? "",
      rentalPropertyId: this.rentalProperty?.id
    }
      this.propertyService.updateRentalPropertyLicense(model).subscribe({
        next: (response) => {
      
        },
        error: (error) => {
        
        },
        complete :() =>{ 
        }
      });
    
  }
}
